import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentsSection, EditerBox } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { CustomPopup, LoadingBox } from "component/basic/popup";
import { bottomChk, isMobile } from "js/function";
import { CarListItem } from "component/product/car";
import { RentPopupContents } from "pages/popup/Popup";
import { FixedPage, FixedSection } from "component/basic";
import { FilterSection } from "component/product/Filter";
import { FixedBox_btnItem, FixedBox_chkItemBox, TermsPopupSubTitle } from "component/app/subItem";
import { NotItems } from "component/basic/notItems";
import { PointFixedTap } from "component/basic/tap";
import { FixedContents } from "component/product/page";

const ReservationList = (props) => {
    const navigate = useNavigate();

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);

    const [page,setPage] =  useState(1);
    const [itemList,setItemList] =  useState([]);

    const [category,setCategory] =  useState("");
    
    let lastPage = false;
    let settingChk = 0;

    const pageDataApi = useGet({
        url:`/reservation?page=${page}&status=${category}`,
        loginType:"login"
    });
    const pageData = pageDataApi?.data?.reservations;

    const shuttleApi = useGet({
        url:`/shuttle`,
        loginType:"login"
    });
    const shuttleData = shuttleApi?.data;

    const reservationApi = useGet({
        url:`/reservation/rule`,
        loginType:"login"
    });
    const reservationData = reservationApi?.data;

    const [shuttlePopup,setShuttlePopup] =  useState(null);
    const [reservationPopup,setReservationPopup] =  useState(null);
    const [rentPopup,setRentPopup] =  useState(null);

    const [addrPosition,setAddrPosition] =  useState(null);
    
    useEffect(() => {
        setItemList([]);
        setPage(1);
    }, [category]);

    function addPage(){
        setLoadingBoxOpen(true);
        setPage(page + 1);
        settingChk = 1;
        setTimeout(() => {
            settingChk = 0;
        }, 300);
    };

    useEffect(() => {
        if(pageData?.data && pageData?.data.length > 0){
            if(page == 1){
                setItemList([...pageData?.data]);
            }else{    
                setItemList(prev => [...prev, ...pageData?.data]);
            }
        }else{
            setItemList([]);
        }

        lastPage = pageData?.current_page < pageData?.last_page;

        setLoadingBoxOpen(false);

        window.removeEventListener("scroll", handleScroll);
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [pageDataApi]);

    function handleScroll(){
        if(bottomChk() && lastPage && settingChk == 0){
            addPage();
        }
    };

    useEffect(() => {
        setItemList([]);
        const timer = setInterval(() => {
            window.addEventListener("scroll", handleScroll);
        }, 100);
        return () => {
            clearInterval(timer);
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            <ContentsSection
                header={true}
                footer={true}
                addClass={"gBg mTapContents"}
            >
                <Header
                    addClass=""
                    logo={true}
                    mMenu={true}
                    pageBack={false}
                    func={()=>{}}
                    headTitle={null}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={1}
                    closeFunc={()=>{}}
                />
                <PointFixedTap
                    boxAddClass={"mItemT"}
                    headerTap={true}
                    headerChk={true}
                    addClass=""
                    data={[
                        {id:"",name:"전체"},
                        {id:0,name:"이용 예정"},
                        {id:1,name:"이용 중"},
                        {id:2,name:"이용 완료"},
                        {id:10,name:"예약 취소"}
                    ]}
                    nameKey="name"
                    valKey="id"
                    val={category}
                    func={(name,val)=>{setCategory(val)}}
                />
                <FixedPage addClass="reverse">
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass="fixedsection_min"
                        addClass="fixedArea_min"
                        contentsBox="fixedPage"
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        <FilterSection>
                            <FixedBox_chkItemBox
                                addClass="pcItemT"
                                title="예약 확인"
                                value={category}
                                data={[
                                    {id:"",name:"전체"},
                                    {id:0,name:"이용 예정"},
                                    {id:1,name:"이용 중"},
                                    {id:2,name:"이용 완료"},
                                    {id:10,name:"예약 취소"}
                                ]}
                                func={(id)=>{setCategory(id)}}
                            />
                            {shuttleData ? 
                                <FixedBox_btnItem
                                    text={"셔틀버스 이용 안내"}
                                    icon={"/assets/images/icon/reservation_icon_0.svg"}
                                    addClass=""
                                    func={()=>{
                                        setShuttlePopup({
                                            addClass:"",
                                            title:"셔틀버스 이용 안내",
                                            subTitle:null,
                                            closeType:true,
                                            closeFunc:(e) => {setShuttlePopup(null)},
                                            closePcOn:true
                                        });
                                    }}
                                />
                            :""}
                            {addrPosition ? 
                                <FixedBox_btnItem
                                    text={"렌터카 대여/반납지 안내"}
                                    icon={"/assets/images/icon/reservation_icon_1.svg"}
                                    addClass=""
                                    func={()=>{
                                        setRentPopup({
                                            addClass:"",
                                            title:"렌터카 대여/반납지 안내",
                                            subTitle:null,
                                            closeType:true,
                                            closeFunc:(e) => {setRentPopup(null)},
                                            closePcOn:true
                                        });
                                    }}
                                />
                            :""}
                            {reservationData ? 
                                <FixedBox_btnItem
                                    text={"예약 취소/변경 규정 안내"}
                                    icon={"/assets/images/icon/reservation_icon_2.svg"}
                                    addClass=""
                                    func={()=>{
                                        setReservationPopup({
                                            addClass:"",
                                            title:"예약 취소/변경 규정 안내",
                                            subTitle:null,
                                            closeType:true,
                                            closeFunc:(e) => {setReservationPopup(null)},
                                            closePcOn:true
                                        });
                                    }}
                                />
                            :""}
                        </FilterSection>
                    </FixedSection>
                    <FixedContents>
                        {itemList && itemList?.length > 0 ? 
                            <>
                                {itemList && itemList?.map((item, i) => (
                                    <CarListItem
                                        key={i}
                                        type="reservation"
                                        addClass=""
                                        id={item?.id}
                                        model_id={item?.model_id}
                                        car_image={item?.image_url}
                                        car_image_alt={item?.image_alt}
                                        maker={item?.maker}
                                        modelName={item?.name}
                                        passengerNum={item?.passenger_number}
                                        fuelType={item?.fuel}
                                        min_year={item?.min_year}
                                        max_year={item?.max_year}
                                        insuranceName={item?.insurance_name}

                                        carOptions={item?.options}

                                        status={item?.status}
                                        reservationId={item?.reservation_code}
                                        startDtm={item?.start_date}
                                        endDtm={item?.end_date}
                                        payment_price={item?.payment_price}

                                        reservation_cancel_request={item?.reservation_cancel_request}
                                    />
                                ))}
                            </>
                        :
                            <NotItems addClass="fullPage" text={`예약 내역이 없습니다.`}/>
                        }
                    </FixedContents>
                </FixedPage>
            </ContentsSection>
            <CustomPopup data={shuttlePopup} basicPB={true} mSize={true}>
                <EditerBox addClass="" data={shuttleData?.contents}/>
            </CustomPopup>

            <CustomPopup data={reservationPopup} basicPB={true} mSize={true}>
                <TermsPopupSubTitle title={"예약 취소 규정"}/>
                <EditerBox addClass="minSize" data={reservationData?.cancel_information}/>
                <TermsPopupSubTitle title={"예약 변경 규정"}/>
                <EditerBox addClass="minSize" data={reservationData?.exchange_information}/>
            </CustomPopup>

            <CustomPopup data={rentPopup} basicPB={addrPosition?.lat && addrPosition?.lng && isMobile() ? false : true} mSize={true}>
                <RentPopupContents
                    popup={rentPopup}
                    func={(addrData)=>{setAddrPosition(addrData)}}
                />
            </CustomPopup>

            <Footer/>
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default ReservationList;